import { render, staticRenderFns } from "./SupplierReturnFilters.vue?vue&type=template&id=406141ec&"
import script from "./SupplierReturnFilters.vue?vue&type=script&lang=js&"
export * from "./SupplierReturnFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports